/*eslint-disable*/
import React, { useEffect } from "react";
import firebase from "../../utils/firebase";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
// react components for routing our app without refresh
import { Link } from "react-router-dom";
import SportsEsportsIcon from "@material-ui/icons/SportsEsports";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
// @material-ui/core components

import {
  List,
  Avatar,
  Typography,
  Hidden,
  makeStyles,
  ListItem,
  Tooltip,
  Badge,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";

// core components
import CustomDropdown from "components/MaterialKit/CustomDropdown/CustomDropdown.js";
import Button from "components/MaterialKit/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

import RssFeedIcon from "@material-ui/icons/RssFeed";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import {
//   MY_PROFILE,
//   HOME,
//   LOGIN,
//   REGISTER,
//   MANAGE_ACOUNT,
//   MY_POSTS,
// } from 'constants/routes';
import {
  LOGIN,
  HOME,
  MY_PROFILE,
  REGISTER,
  MANAGE_ACOUNT,
  MY_POSTS,
  CREATE_POST,
  CHAT,
  CREATE_STREAM,
  DASHBOARD,
} from "../../constants/routes";
import { logout } from "slices/authSlice";
import Loader from "components/Loader/Loader";
import { clearNotifications } from "slices/authSlice";
import { loadUser } from "slices/authSlice";

const useStyles = makeStyles(styles);

export default function NavbarLinks(props) {
  const {
    auth: { isAuthenticated, user, loading, notificationLoading },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);
  const dispatch = useDispatch();
  let prevLength = 0;

  useEffect(() => {
    if (user !== null) {
      prevLength = user.notification.length;
    }
  }, []);

  // useEffect(() => {
  //   dispatch(loadUser());
  // }, [user !== null ? user.notification.length : '']);

  const classes = useStyles();

  return (
    <List className={classes.list}>
      {!isAuthenticated || user === null ? (
        <>
          <ListItem className={classes.listItem}>
            <Link to={HOME} className={classes.navLink}>
              <Button color="transparent">
                <i className="fas fa-home"></i> HOME
              </Button>
            </Link>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Link to={LOGIN} className={classes.navLink}>
              <Button color="transparent">
                <i className="fas fa-sign-in-alt"></i>
                Login
              </Button>
            </Link>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Link to={REGISTER} className={classes.navLink}>
              <Button color="transparent">
                <i class="fas fa-user-plus"></i> Register
              </Button>
            </Link>
          </ListItem>
        </>
      ) : (
        <>
          <ListItem className={classes.listItem}>
            <Link to={HOME} className={classes.navLink}>
              <Button color="transparent">
                <i className="fas fa-home"></i> Dashboard
              </Button>
            </Link>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Link to={MY_POSTS} className={classes.navLink}>
              <Button color="transparent">
                <SportsEsportsIcon />
                My Posts
              </Button>
            </Link>
          </ListItem>

          <ListItem className={classes.listItem}>
            {!user.isLive ? (
              <Link to={CREATE_STREAM} className={classes.navLink}>
                <Button color="transparent">
                  <RssFeedIcon /> Live Stream
                </Button>
              </Link>
            ) : (
              <Link
                to={`${DASHBOARD}/user/streams/watch/${user.liveStreamInfo.streamKey}`}
                className={classes.navLink}
              >
                <Button color="transparent">
                  <RssFeedIcon /> Live Stream
                </Button>
              </Link>
            )}
          </ListItem>

          <ListItem className={classes.listItem}>
            <CustomDropdown
              hoverColor="info"
              caret={false}
              noLiPadding={true}
              dropdownHeader={
                <div style={{ justifyContent: "center", display: "flex" }}>
                  <Hidden smDown implementation="css">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      <h4 style={{ color: "white" }}>Notifications</h4>
                      <Button
                        loading={notificationLoading}
                        color="transparent"
                        disabled={user.notification.length === 0 ? true : false}
                        style={{ color: "red" }}
                        onClick={() => dispatch(clearNotifications())}
                      >
                        clear
                      </Button>
                    </div>
                  </Hidden>
                </div>
              }
              buttonText={
                <div style={{ justifyContent: "center", display: "flex" }}>
                  {user.notification.length > 0 && (
                    <Badge
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      color="secondary"
                      variant="dot"
                    />
                  )}
                  <Hidden smUp implementation="css">
                    <h6>Notifications</h6>
                  </Hidden>
                </div>
              }
              buttonIcon={NotificationsNoneIcon}
              buttonProps={{
                className: classes.navLink,
                color: "transparent",
              }}
              backgroundStyle={{
                height: 400,
                // width: 300,
                overflowY: "scroll",
                background: "linear-gradient(315deg, #000000 0%, #414141 74%",
                color: "white",
              }}
              dropdownList={user.notification.map((message) => {
                return (
                  <Link to={`/dashboard/profile/${message.user.username}`}>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <Avatar alt={message._id} src={message.user.photo} />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <span style={{ color: "white" }}>
                            {message.user.name}
                          </span>
                        }
                        secondary={
                          <React.Fragment>
                            {/* <Typography
                            component='span'
                            variant='body2'
                            // className={classes.inline}
                            style={{ display: 'inline' }}
                            style={{ color: 'white' }}
                          > */}
                            <div
                              style={{
                                color: "white",
                                wordWrap: "break-word",
                              }}
                            >
                              {" "}
                              {message.message}
                            </div>
                            {/* </Typography> */}
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                  </Link>
                );
              })}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <CustomDropdown
              left
              noLiPadding={true}
              dropdownHeader={
                <div style={{ justifyContent: "center", display: "flex" }}>
                  <Hidden smDown implementation="css">
                    <h4 style={{ color: "white" }}>
                      {user.name.toUpperCase()}
                    </h4>
                  </Hidden>
                </div>
              }
              backgroundStyle={{
                background: "linear-gradient(315deg, #000000 0%, #414141 74%",
                color: "white",
              }}
              caret={true}
              hoverColor="black"
              buttonText={
                <div style={{ justifyContent: "center", display: "flex" }}>
                  <img
                    style={{ marginLeft: "1rem" }}
                    src={user.photo}
                    className={classes.img}
                    alt="profile"
                  />
                  <Hidden smUp implementation="css">
                    <h6 style={{ marginLeft: "1rem" }}>{user.name}</h6>
                  </Hidden>
                </div>
              }
              buttonProps={{
                className: classes.navLink + " " + classes.imageDropdownButton,
                color: "transparent",
              }}
              dropdownList={[
                <Link
                  to={MY_PROFILE}
                  style={{ color: "white" }}
                  className={classes.navLink}
                >
                  <Button color="transparent">
                    <i
                      className="fas fa-user"
                      style={{ marginRight: "1rem" }}
                    ></i>
                    My Profile
                  </Button>
                </Link>,
                <Link
                  to={MANAGE_ACOUNT}
                  style={{
                    color: "white",
                  }}
                  className={classes.navLink}
                >
                  <Button color="transparent">
                    <i
                      className="far fa-user-circle"
                      style={{ marginRight: "1rem" }}
                    ></i>{" "}
                    Manage Account
                  </Button>
                </Link>,
                <Link
                  onClick={() => {
                    firebase.auth().signOut();
                    dispatch(logout());
                  }}
                  style={{ color: "white" }}
                  className={classes.navLink}
                >
                  <Button color="transparent">
                    <i
                      className="fas fa-sign-out-alt"
                      style={{ marginRight: "1rem" }}
                    ></i>{" "}
                    Logout
                  </Button>
                </Link>,
              ]}
            />
          </ListItem>
        </>
      )}
    </List>
  );
}
